import cashRegisterReceipts from './cash-register-receipts.json';
import counterparties from './counterparties.json';
import dashboard from './dashboard.json';
import ikpus from './ikpus.json';
const edo = {
   'edo-cash-register-receipts': cashRegisterReceipts,
   'edo-counterparties': counterparties,
   'edo-dashboard': dashboard,
   'edo-ikpus': ikpus,
};
export default edo;
